const Faq = () => {

    const faqItems = document.querySelectorAll(".faq__wrapper-items-item");

    if(faqItems) {
        faqItems.forEach(item => {
            const title = item.querySelector(".faq__wrapper-items-item-top");
            const content = item.querySelector(".faq__wrapper-items-item-value");
    
            title.addEventListener("click", function () {
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                    item.classList.remove("active");
                } else {
                    content.style.maxHeight = content.scrollHeight + "px";
                    item.classList.add("active");
                }
            });
        });
    }

}

export default Faq;